import {Selector} from '@ngxs/store';
import {ScheduleState} from '@store/schedule/schedule.state';
import {ScheduleStateModel} from '@store/schedule/schedule-state.model';
import {IGroup} from '@interfaces/group';
import {IDevice, IDeviceArea} from '@interfaces/devices';
import {ISchedule} from '@interfaces/schedule';

export class ScheduleSelectors {
  @Selector([ScheduleState])
  static getScheduledGroups(state: ScheduleStateModel): IGroup[] {
    return state.groups;
  }

  @Selector([ScheduleState])
  static getScheduledDevices(state: ScheduleStateModel): IDevice[] {
    return state.devices;
  }

  @Selector([ScheduleState])
  static getScheduledDevicesTotal(state: ScheduleStateModel): number {
    return state.totalDevices;
  }

  @Selector([ScheduleState])
  static getScheduledGroupsTotal(state: ScheduleStateModel): number {
    return state.totalGroups;
  }

  @Selector([ScheduleState])
  static getDevicesCurrentPage(state: ScheduleStateModel): number {
    return state.devicesCurrentPage;
  }

  @Selector([ScheduleState])
  static getGroupsCurrentPage(state: ScheduleStateModel): number {
    return state.groupsCurrentPage;
  }

  @Selector([ScheduleState])
  static getItemsPerPage(state: ScheduleStateModel): number {
    return state.itemsPerPage;
  }

  @Selector([ScheduleState])
  static getSearchValue(state: ScheduleStateModel): string {
    return state.searchParam;
  }

  @Selector([ScheduleState])
  static getActiveTab(state: ScheduleStateModel): 'group' | 'device' {
    return state.activeTab;
  }

  @Selector([ScheduleState])
  static getScheduleToCreateData(state: ScheduleStateModel): ISchedule {
    return state.scheduleToCreate.mainData;
  }

  @Selector([ScheduleState])
  static getActiveSchedule(state: ScheduleStateModel): IDeviceArea[] | null {
    return state.activeSchedule;
  }

  @Selector([ScheduleState])
  static getDeviceGroupName(state: ScheduleStateModel): string {
    return state.scheduleToCreate.deviceGroupName;
  }

  @Selector([ScheduleState])
  static getScheduleDescription(state: ScheduleStateModel): string {
    return state.scheduleToCreate.description;
  }

  @Selector([ScheduleState])
  static isEditMode(state: ScheduleStateModel): boolean {
    return state.editMode;
  }
}
